module.exports = __webpack_public_path__ + "static/media/img12.5513209e.jpeg";